import { FitnessLevel } from 'constants/user';

import * as actionTypes from './actionTypes';
import { ActionType, PersonalPlanState } from './types';

export const initialState: PersonalPlanState = {
    currentDay: 1,
    planDays: [],
    isCurrentPlanComplete: false,
    isCompletePlanModalVisible: false,
    currentPlanId: null,
    currentPlanLevel: FitnessLevel.Beginner,
    totalPlanDays: 0,
    statistics: {
        days: 0,
        duration: null,
        kcal: null,
    },
    workout: {
        blocks: [],
        duration: null,
        exercise_count: null,
        calories: null,
        description: null,
        workout_id: null,
    },
    yogaType: null,
    planType: null,
    instructor: null,
    beyondExercisesOn: null,
    savasanaState: null,
    planDuration: null,
    workoutDuration: null,
    yogaPlanId: null,
};

const personalPlanReducer = (state = initialState, action: ActionType): PersonalPlanState => {
    switch (action.type) {
        case actionTypes.GET_COMPLETED_PLAN_STATISTICS_SUCCESS:
            return { ...state, statistics: { ...action.payload.data } };

        case actionTypes.GET_CURRENT_PLAN_SUCCESS:
            return {
                ...state,
                currentPlanLevel: action.payload.days[0].level,
                planDays: action.payload.days,
                totalPlanDays: action.payload.days.length,
                currentDay: action.payload.current_day,
                currentPlanId: action.payload.id,
                yogaType: action.payload.yoga_type,
                planType: action.payload.plan_type,
                instructor: action.payload.instructor,
            };

        case actionTypes.GET_WORKOUT_SUCCESS:
            return { ...state, workout: { ...action.payload } };

        case actionTypes.SET_CURRENT_PLAN_COMPLETION:
            return { ...state, isCurrentPlanComplete: action.payload };

        case actionTypes.SET_COMPLETE_PLAN_MODAL_VISIBILITY:
            return { ...state, isCompletePlanModalVisible: action.payload };

        case actionTypes.SET_LAST_PLAN_DAY_HATCH:
            return {
                ...state,
                currentDay: action.payload.currentDay,
                planDays: action.payload.workouts,
            };

        case actionTypes.RESET_WORKOUT:
            return {
                ...state,
                workout: initialState.workout,
            };

        case actionTypes.SET_PLAN_PERSONALIZATION_DATA:
            return {
                ...state,
                yogaType: action.payload.yoga_type,
                beyondExercisesOn: action.payload.beyond_exercises_on,
                planDuration: action.payload.plan_duration,
                workoutDuration: action.payload.workout_duration,
                savasanaState: action.payload.savasana_state,
                instructor: action.payload.instructor,
                yogaPlanId: action.payload.yoga_plan_id,
            };

        default:
            return state;
    }
};

export default personalPlanReducer;
